import React from "react";

const InlineSpinner = () => {
  return <span className="loader"></span>;
};

export default InlineSpinner;
